import { MouseEvent, useState } from 'react'
import { Badge, Box, Button, Divider, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import NotificationsIcon from '@mui/icons-material/Notifications'
import moment from 'moment'
import { getNotificationOrderUrl, useNotifications } from '../../context/notifications'
import { BoardguardPdfDownload } from '../BoardguardPdfDownload'

export const NotificationBell = () => {
    const { enabled, notifications, unread, markRead, markAllRead } = useNotifications()
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

    if (!enabled) return null

    const onOpen = (event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)
    const onClose = () => setAnchorEl(null)

    return (
        <>
            <Tooltip title="Notificações">
                <IconButton color="inherit" onClick={onOpen} sx={{ mr: 2 }}>
                    <Badge color="error" badgeContent={unread} max={99}>
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={onClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{ paper: { sx: { width: 380, maxHeight: 480 } } }}
            >
                <Box className="flex items-center justify-between" sx={{ px: 2, py: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold">Notificações</Typography>
                    {unread > 0 && (
                        <Button size="small" onClick={() => void markAllRead()}>
                            Marcar todas como lidas
                        </Button>
                    )}
                </Box>
                <Divider />
                {notifications.length === 0 && (
                    <Box sx={{ px: 2, py: 3 }}>
                        <Typography variant="body2" color="text.secondary" align="center">
                            Nenhuma notificação por enquanto.
                        </Typography>
                    </Box>
                )}
                {notifications.map((notification) => {
                    const orderId = notification.order_id
                    const pdfReady = !!notification.order?.boardguard_ticket?.pdf_ready

                    return (
                        <MenuItem
                            key={notification.id}
                            onClick={() => {
                                void markRead(notification.id)
                                onClose()
                                if (orderId) window.location.href = getNotificationOrderUrl(orderId)
                            }}
                            sx={{
                                whiteSpace: 'normal',
                                alignItems: 'flex-start',
                                gap: 1,
                                backgroundColor: notification.read_at ? undefined : 'action.hover',
                            }}
                        >
                            <Box className="flex flex-1 flex-col">
                                <Typography variant="body2" fontWeight={notification.read_at ? 'normal' : 'bold'}>
                                    {notification.title}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {notification.message}
                                </Typography>
                                <Typography variant="caption" color="text.disabled">
                                    {moment(notification.created_at).format('DD/MM/YYYY HH:mm')}
                                </Typography>
                            </Box>
                            {orderId && pdfReady && (
                                <BoardguardPdfDownload
                                    variant="icon"
                                    orderId={orderId}
                                    reservationCode={notification.order?.reservation_code}
                                    onDownloaded={() => void markRead(notification.id)}
                                />
                            )}
                        </MenuItem>
                    )
                })}
            </Menu>
        </>
    )
}
